<template>
  <div class="box f-c-c">
    <oss-img src="https://img.kakaclo.com/web-img/index/empty.png" :wdith="258" :height="200" />
    <div v-if="isPC">
      <div style="margin: 50px 0 26px 0;">{{ $t('Index.Components.ProductEmpty.Tips1') }}"</div>
      <div class= "f-c-c">
         <el-button type="primary" round @click="$router.push('/customizedAdd')">{{ $t('Index.Components.ProductEmpty.INeedCustomization') }}</el-button>
      </div>
    </div>
    <div v-else class="mobile-btn" @click="$router.push('/customizedAdd')">
      {{ $t('Index.Components.ProductEmpty.INeedCustomization') }}
    </div>
  </div>
</template>

<script>
import OssImg from '@/components/OssImg.vue'
export default ({
  components: {
    OssImg
  }
})
</script>

<style lang="scss" scoped>
.box {
  // width: 258px;
  flex-direction: column;

  img {
    width: 258px;
  }

  .btn {
    width: 80px;
    height: 30px;
    border: 1px solid #8B93A3;
    border-radius: 30px;
  }
}

.mobile-btn {
  margin: 0 auto;
  margin-top: 1.6rem;
  background: #99C41C;
  color: #fff;
  width: 3.2rem;
  height: .68rem;
  text-align: center;
  line-height: .68rem;
  border-radius: .68rem;
}
</style>
